export default __webpack_public_path__ + "static/media/FAQ_1_2.6c3e142b.png";